/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { formatLocalDate } from 'volta/utils/date-utils';

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type StoreService from 'volta/services/store';
import type Task from 'volta/models/task';
import type { CellBaseCellSignature } from 'volta/components/cell/base-cell';

export default class CellTaskCellComponent extends Component<CellBaseCellSignature> {
  @service store!: StoreService;

  @tracked scrollToDate?: string;
  @tracked tasks: Task[] = [];

  get count() {
    return this.tasksWithSameDueDate.length;
  }

  get criticality() {
    const ranks = ['success', undefined, 'warning', 'danger'];
    const bestCriticality = this.tasksWithSameDueDate.reduce((acc, task) => {
      const rank = ranks.indexOf(task.todoCriticality || undefined);
      if (rank > acc) {
        acc = rank;
      }
      return acc;
    }, 0);
    return [undefined, undefined, 'danger', 'danger'][bestCriticality] as 'hud' | 'danger';
  }

  get tasksWithSameDueDate() {
    if (this.scrollToDate) {
      const formattedDueDate = formatLocalDate(this.scrollToDate);
      return this.tasks.filter((task) => {
        if (task) {
          if (!task.dueDate || task.resolvedAt) {
            return false;
          }
          return formatLocalDate(task.dueDate) === formattedDueDate;
        } else {
          return false;
        }
      });
    }
    return [];
  }

  @action
  update(tasks: Task[], date: string) {
    this.tasks = tasks;
    this.scrollToDate = date;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::TaskCell': typeof CellTaskCellComponent;
    'cell/task-cell': typeof CellTaskCellComponent;
  }
}
